import { decodeToken } from 'react-jwt'

export default function useUserRole(): {
  role: string | null
  isAdmin: boolean
} {
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE
  const userInfos = JSON.parse(
    localStorage.getItem(
      `@@auth0spajs@@::${clientId}::${audience}::openid profile email offline_access`
    ) ?? '{}'
  )
  const token = userInfos?.body?.access_token
  const decoded: any = decodeToken(token)
  const role: string | null = decoded?.role ?? null
  return { role, isAdmin: role === 'Administrador' }
}
